import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import Imagen1 from "../../../images/modulo13/deforestar.png";
import Imagen2 from "../../../images/modulo13/camiondeforestar.png";
import GuiaDocente from "../../../components/GuiaDocente";

import Sidebar from "../Sidebar";

const Actividad8 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[10];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[9].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[9].path}`,
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[11].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[11].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5">
        <h2>La importancia de respetar el territorio</h2>
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-md-3">
            <p>
              Si bien los seres humanos estamos constantemente transformando
              nuestro territorio, es importante que comprendamos que nuestras
              acciones tienen un <strong>impacto</strong> sobre el espacio en el
              que vivimos. En nuestro país, debemos comprender la importancia de{" "}
              <strong>convivir respetuosamente</strong> con el medio ambiente.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-5">
            <p>
              En la Amazonía, por ejemplo, existe el problema de la
              deforestación. Al talar excesivamente los árboles afectamos a los
              animales y plantas de la zona. Los terrenos despojados de
              vegetación se vuelven improductivos para la agricultura.
            </p>
            <p>
              Otras actividades productivas generan contaminación del agua, el
              suelo y el aire si es que no respetan las normas de{" "}
              <strong>conservación</strong>.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que observen las imágenes y lean en silencio el texto titulado:
            La importancia de respetar el territorio. Luego léala una vez más en
            voz alta. Mencione la importancia de comprender que las acciones
            humanas tienen efectos en el entorno. Muchos de estos son
            irreversibles. Retome los ejemplos del texto y resalte la
            importancia de aprender a convivir con nuestro territorio.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
